// Orders/TabContent/TemplatesOrders.js
import React from "react";

const TemplatesOrders = () => {
  return (
    <div className="p-6">
      <h3 className="text-lg font-bold">Order Templates</h3>
      <p className="text-gray-600">
        Save and manage order templates for quicker reordering.
      </p>
    </div>
  );
};

export default TemplatesOrders;
